export default {"src":"/_next/static/media/DUOL.f39f537a.svg","height":18,"width":18};